import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _SkeletonList;
var _excluded = ["loading", "error", "searchFilter", "sessions", "recentAddedSession", "variant", "onRefresh"];
import { useEffect, useRef, useState } from 'react';
import { useLiveSessionsTranslation } from "../../hooks/useLiveSessionsTranslation";
import { EmptySearch } from "../ui/EmptySearch";
import { EmptySessions } from "../ui/EmptySessions";
import { ErrorLoadingSessions } from "../ui/ErrorLoadingSessions";
import { NewLiveSessionCard } from "../ui/NewLiveSessionCard";
import { SkeletonList } from "../ui/SkeletonList";
import { PastSessions } from "./PastSessions";
import { UpcomingSessions } from "./UpcomingSessions";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var SCROLL_SIZE = 15;
export var LiveSessionsList = function LiveSessionsList(_ref) {
  var loading = _ref.loading,
    error = _ref.error,
    searchFilter = _ref.searchFilter,
    sessions = _ref.sessions,
    recentAddedSession = _ref.recentAddedSession,
    variant = _ref.variant,
    onRefresh = _ref.onRefresh,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var urlSearchParams = new URLSearchParams(window.location.search);
  var hasQueryParamsOfApps = urlSearchParams.get('isFromApps');
  var isFromApps = hasQueryParamsOfApps === 'true';
  var _useState = useState(SCROLL_SIZE),
    _useState2 = _slicedToArray(_useState, 2),
    sessionsToShow = _useState2[0],
    setSessionsToShow = _useState2[1];
  var _useLiveSessionsTrans = useLiveSessionsTranslation(),
    t = _useLiveSessionsTrans.t;
  var bottomRef = useRef(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    setSessionsToShow(SCROLL_SIZE);
  }, [variant]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    var ref = bottomRef.current;
    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        setSessionsToShow(function (prev) {
          return prev < sessions.length ? prev + SCROLL_SIZE : sessions.length;
        });
      }
    });

    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (ref) observer.observe(ref);
    return function () {
      // biome-ignore lint/style/useBlockStatements: single-line early return
      if (ref) observer.unobserve(ref);
    };
  }, [bottomRef, sessions.length]);

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (loading) return _SkeletonList || (_SkeletonList = /*#__PURE__*/_jsx(SkeletonList, {}));

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (error) return /*#__PURE__*/_jsx(ErrorLoadingSessions, {
    onRefresh: onRefresh
  });

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (searchFilter && sessions.length === 0) return /*#__PURE__*/_jsx(EmptySearch, {
    searchFilter: searchFilter
  });

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (sessions.length === 0) return /*#__PURE__*/_jsx(EmptySessions, {
    title: t(variant === 'upcoming' ? 'NO_UPCOMING_SESSIONS' : 'NO_PAST_SESSIONS'),
    subtitle: variant === 'upcoming' ? t('NO_UPCOMING_SESSIONS_DESCRIPTION') : undefined
  });
  var sessionsWithoutRecentAdded = sessions.filter(function (session, index) {
    return session.id !== (recentAddedSession === null || recentAddedSession === void 0 ? void 0 : recentAddedSession.id) && index < sessionsToShow;
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("div", {
        className: "tw-relative",
        children: [recentAddedSession && otherProps.isAdmin && /*#__PURE__*/_jsx("div", {
          className: "tw-mb-2.4",
          children: /*#__PURE__*/_jsx(NewLiveSessionCard, _objectSpread({
            session: recentAddedSession
          }, otherProps))
        }), variant === 'upcoming' ? /*#__PURE__*/_jsx(UpcomingSessions, _objectSpread({
          sessions: sessionsWithoutRecentAdded,
          onRefresh: onRefresh,
          isFromApps: isFromApps
        }, otherProps)) : /*#__PURE__*/_jsx(PastSessions, _objectSpread({
          sessions: sessionsWithoutRecentAdded
        }, otherProps))]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "tw-w-full tw-h-0.4",
      ref: bottomRef
    })]
  });
};